import { render, staticRenderFns } from "./Sangria.vue?vue&type=template&id=6dbdae53&scoped=true"
import script from "./Sangria.vue?vue&type=script&lang=js"
export * from "./Sangria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbdae53",
  null
  
)

export default component.exports